import { Sparkles, Gift, Heart } from "lucide-react";

/**
 * KidsGamesBlock, petite attention pour les familles voyageant avec enfants.
 * Affiché sur les fiches villes du Morbihan (dépt 56) en priorité.
 */
const KidsGamesBlock = ({ cityName }) => (
  <section
    data-testid={`kids-games-block-${cityName}`}
    className="py-16 md:py-20 bg-gradient-to-br from-sand via-cream to-sand"
  >
    <div className="max-w-6xl mx-auto px-6 lg:px-10">
      <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        {/* Image */}
        <div className="relative order-2 lg:order-1">
          <div className="absolute -inset-3 bg-gold/15 rounded-3xl rotate-1" />
          <img
            src="/images/kit-jeux-enfants-terre-et-mer.jpg"
            alt={`Kit de jeux enfants Terre et Mer Conciergerie offert dans nos locations Airbnb à ${cityName}`}
            loading="lazy"
            decoding="async"
            className="relative rounded-3xl shadow-soft w-full"
          />
        </div>

        {/* Content */}
        <div className="order-1 lg:order-2">
          <div className="inline-flex items-center gap-2 text-gold uppercase tracking-[0.22em] text-xs font-semibold mb-5">
            <Heart size={14} fill="currentColor" strokeWidth={0} />
            Petite attention famille
          </div>
          <h2 className="font-serif text-3xl md:text-4xl text-ink leading-tight mb-6">
            Un kit de jeux <em className="text-gold not-italic">offert</em> aux
            enfants de vos voyageurs
          </h2>
          <p className="text-ink/75 leading-relaxed text-base md:text-lg mb-6">
            Quand une famille réserve votre logement à {cityName}, nous déposons
            à leur arrivée un <strong>livret de jeux Terre et Mer</strong>{" "}
            entièrement illustré sur le thème de la mer (voiliers, phares,
            coquillages…) avec des crayons de couleur. Coloriages, labyrinthes,
            sudokus marins, mots mêlés, jeu des 7 différences : 8 activités pour
            occuper les petits voyageurs les jours de pluie ou en fin de
            journée à la plage.
          </p>
          <ul className="space-y-3 mb-8">
            {[
              {
                icon: <Gift size={18} />,
                title: "Inclus, sans surcoût pour vous",
                desc: "Kit fourni gratuitement par notre équipe à chaque réservation famille.",
              },
              {
                icon: <Sparkles size={18} />,
                title: "Avis 5★ presque garantis",
                desc: "Les parents notent systématiquement cette attention dans leurs commentaires.",
              },
              {
                icon: <Heart size={18} />,
                title: "Image de marque locale",
                desc: "Aux couleurs Terre et Mer, design soigné, qualité premium.",
              },
            ].map((item, i) => (
              <li
                key={i}
                className="flex items-start gap-4"
                data-testid={`kids-games-feature-${i}`}
              >
                <span className="flex-shrink-0 w-9 h-9 rounded-full bg-gold/20 text-gold flex items-center justify-center mt-0.5">
                  {item.icon}
                </span>
                <div>
                  <p className="font-semibold text-ink text-base mb-0.5">
                    {item.title}
                  </p>
                  <p className="text-ink/70 text-sm leading-snug">
                    {item.desc}
                  </p>
                </div>
              </li>
            ))}
          </ul>
          <p className="text-ink/60 italic text-sm border-l-2 border-gold/40 pl-4">
            « Un petit geste qui change la perception du séjour. Les enfants
            adorent, et les parents s'en souviennent au moment de laisser
            l'avis. »
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default KidsGamesBlock;
